/**
 * Phone utilities
 */

export function normalizePhone(raw) {
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const normalized = trimmed.replace(/[^\d+]/g, "");
  if (!normalized) return null;
  return normalized;
}

export function toTelHref(raw) {
  const phone = normalizePhone(raw);
  if (!phone) return null;
  return `tel:${phone}`;
}
